import { CommonModule } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { ApiService } from "src/app/services/api.service";
import { SearchData } from "src/app/services/searchData";
import { UtilService } from "src/app/services/util.service";
import { User } from "src/app/types/User";
import { UserCardConfig } from "src/app/types/UserCardConfig";
import Swal from "sweetalert2";
// Removed: import { BusinessEmployeeComponent } from "../business-employee/business-employee.component"; - component should not be imported for injection
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import {
  BehaviorSubject,
  debounceTime,
  distinctUntilChanged,
  Subject,
} from "rxjs";
import { GigsumoConstants } from "src/app/services/GigsumoConstants";
import { CommonSkeletonComponent } from "../../../skeleton/common-skeleton/common-skeleton.component";
import { NodataFoundComponent } from "../../../widget/nodata-found/nodata-found.component";
import { UserCardComponent } from "../../cards/user-card/user-card.component";
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: "app-business-employee-requests",
  standalone: true,
  imports: [BsDropdownModule, 
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    InfiniteScrollModule,
    CommonSkeletonComponent,
    UserCardComponent,
    NodataFoundComponent
  ,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: "./business-employee-requests.component.html",
  styleUrls: ["./business-employee-requests.component.scss"],
})
export class BusinessEmployeeRequestsComponent implements OnInit, OnDestroy {
  /** Wireframe list header (title + count, full-width search pill); false = old Bnav header. */
  useWireframeHeader = true;
  // @Input() commonemit;
  values: any = {};
  // basicDeatils: any;
  // clickEventsubscription: Subscription;
  // isAdmin;
  // isSuperAdmin;
  name;
  // businessId;
  // bussinessName;
  empSearch: any;
  requestsReceivedData: any;
  userId: any;
  noDatafound: Array<string> = ["No data to display!"];
  //Usercard initialization;
  userCardConfig: UserCardConfig[] = [];
  showNoDatafound: boolean = false;
  temppendingList: UserCardConfig[] = [];
  searchKey;
  BusinessManageEmployess: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(
    []
  );
  managePayload = {
    limit: 10,
    businessId: null,
    status: "PENDING",
    searchAfterKey: null,
    searchContent: null,
  };
  search: any;
  stopScroll: boolean = false;
  previouseAfterKey: any = null;
  searchSubject = new Subject<string>();
  scrollSubject = new BehaviorSubject<string>(null);
  loadScroll: boolean = false;
  totalCount: number=0;
  searchContent: any;

  constructor(
    // private commonvalues: CommonValues,
    private searchData: SearchData,
    private api: ApiService,
    private util: UtilService,
    // Removed: private employee: BusinessEmployeeComponent - component should not be injected as service
    private router: Router,
    private fb: UntypedFormBuilder,
    private _activate_route: ActivatedRoute
  ) {
    // this.businessId = route.snapshot.queryParamMap.get("businessId");
    // this.bussinessName = route.snapshot.queryParamMap.get("bussinessName");
    // this.clickEventsubscription = this.commonvalues
    //   .getbusinessid()
    //   .subscribe((res) => {
    //     this.values = res;
    //     this.basicDeatils = res.basicDeatils;
    //   });
  }
  businessData: any;
  responseReceived: boolean = false;
  ngOnInit() {
    this._activate_route.queryParams.subscribe((res) => {
      this.businessData = res;
    });
    // this.values = this.commonemit;
    // this.isAdmin = localStorage.getItem("isAdmin");
    // this.isSuperAdmin = localStorage.getItem("isSuperAdmin");

    this.userId = localStorage.getItem("userId");

    // if (this.isSuperAdmin) {
    //   this.isAdmin = this.isSuperAdmin;
    // }

    let accept: UserCardConfig = new UserCardConfig(
      "Accept",
      this.acceptEmployee,
      this.canShow,
      true
    );
    accept.source = this;
    this.userCardConfig.push(accept);

    let ignore: UserCardConfig = new UserCardConfig(
      "Ignore",
      this.ignoreEmployee,
      this.canShow,
      true
    );
    ignore.source = this;
    this.userCardConfig.push(ignore);

    let revokeBtn: UserCardConfig = new UserCardConfig(
      "Deny",
      this.rejectEmployee,
      this.canShow,
      true
    );
    revokeBtn.source = this;
    this.userCardConfig.push(revokeBtn);
    this.requestlist();

    // Handling search input with debounce to optimize requests and updating the search results by naaz
    this.searchSubject
      .pipe(debounceTime(500),
      distinctUntilChanged())
      .subscribe((res) => {
        this.loadScroll = false;
        this.responseReceived = false;
        this.resetPayload();
        this.managePayload.searchContent = res;
        this.requestlist();
      });
    // Handling scroll events with debounce to load more data when scrolling by naaz
    this.scrollSubject
      .pipe(debounceTime(100),
       distinctUntilChanged())
      .subscribe((res) => {
        if (res != null) {
          this.managePayload.searchAfterKey = this.previouseAfterKey;
          this.requestlist();
        }
      });
  }

  // Resetting payload and scroll-related properties by Naaz
  resetPayload() {
    this.BusinessManageEmployess.next([]);
    this.managePayload.searchAfterKey = null;
    this.previouseAfterKey = null;
    this.stopScroll = false;
    this.totalCount = 0; 
  }

  ngOnDestroy(): void {
    // if (this.clickEventsubscription) {
    //   this.clickEventsubscription.unsubscribe();
    // }
    this.searchSubject.unsubscribe();
    this.scrollSubject.unsubscribe();
  }

  filterName: string = "All";
  findAll() {
    this.userCardConfig = [];
    this.filterName = "All";
    this.ngOnInit();
  }

  pendingList: UserCardConfig[] = [];
  requestlist(param?: string) {
    this.pendingList = [];
    this.util.startLoader();
    this.showNoDatafound = false;
    this.managePayload.businessId = this.businessData?.businessId || null;

    this.api
      .create("business/findBusinessManageEmployees", this.managePayload)
      .subscribe(
        (res) => {
          this.responseReceived = false;
          this.loadScroll = false;
          // if (res && res.data && res.data.pendingtList) {
          this.responseReceived = true;
          if (res.code === GigsumoConstants.SUCESSCODE) {
            const data = res.data.BusinessManageEmployess;
            const searchAfterKey = res.data.searchAfterKey;

            if (
              (data && data.length === 0) ||
              JSON.stringify(this.previouseAfterKey) ===
                JSON.stringify(searchAfterKey)
            ) {
              this.stopScroll = true;
            }

            if(data){
              const current = data.map(element => {
                element[this.managePayload.status === 'IGNORED' ? "ignoredUser" :
                  this.managePayload.status === 'REJECTED' ? "deniedUser" : ""] = true
                element.showAccept = true;
                element.page = "employeerequest"; // Set page identifier for user-card component
                return element;
              });;
              const exist = this.BusinessManageEmployess.getValue();
              const combined = [...exist, ...current];
              if(combined.length > 0){
                combined[0].showAccept = true;
              }
              this.BusinessManageEmployess.next(combined);
              this.previouseAfterKey = searchAfterKey;

              this.temppendingList = this.BusinessManageEmployess.getValue();
            }


            if (res.data.totalCount !== undefined) {
              this.totalCount = res.data.totalCount;
            }
            else {
  this.totalCount = this.BusinessManageEmployess.getValue().length;
}
            this.showNoDatafound = this.BusinessManageEmployess.getValue().length === 0;

            // res.data.pendingtList = this.removeDuplicates(res.data.pendingtList, "userId");
            // res.data.pendingtList.forEach(element => {
            //   element.userName = element.firstName + " " + element.lastName;
            //   element.fullName = element.firstName + " " + element.lastName;
            //   element.page = 'businessEmployeeRequests'
            //   element.requestSentTitle = element.title
            //   element.requestSentOrganization = element.organisation;
            //   element.showAccept = true;
            //   element.page = "employeerequest";
            // });

            // this.pendingList = this.sort_by_key(res.data.pendingtList, "firstName");
            // this.temppendingList = this.pendingList;
            // this.setEmployeeRequestDetailOnBusiness(res.data.pendingtList);

            // localStorage.setItem("reqPendinCnt", res.data.pendingtList.length);

            // }
          }
        },
        (err) => {
          this.util.stopLoader();
        }
      );

    this.util.stopLoader();
  }

  ignored() {
    let data: any = {};
    data.businessId = this.businessData.businessId;
    data.status = "IGNORED";
    this.filterName = "Ignored";
    this.api
      .create("business/findBusinessManageEmployees", data)
      .subscribe((res) => {
        const pendingList: Array<any> = res.data.ignoredList;
        if (pendingList != null) {
          pendingList.forEach((ele) => {
            ele.ignoredUser = true;
            ele.showAccept = true;
          });
          this.pendingList = pendingList;
        }

        this.userCardConfig = [];
        let accept: UserCardConfig = new UserCardConfig(
          "Accept",
          this.acceptEmployee,
          this.canShow,
          true
        );
        accept.source = this;
        this.userCardConfig.push(accept);
      });
  }

  // Applying filters based on the value of val, updating filterName, status, and reloading by Naaz
  apply(val: string) {
    this.loadScroll = false;
    this.responseReceived = false;
    if (val === "PENDING") {
      this.filterName = "All";
    } else if (val === "IGNORED") {
      this.filterName = "Ignored";
    } else if (val === "REJECTED") {
      this.filterName = "Denied";
    } else {
      this.filterName = val;
    }
    this.managePayload.status = val;
    this.resetPayload();
    this.requestlist();
  }

  denied() {
    let data: any = {};
    data.businessId = this.businessData.businessId;
    data.status = "REJECTED";
    this.filterName = "Denied";
    this.api.create("business/findBusinessManageEmployees", data)
      .subscribe((res) => {
        const pendingList: Array<any> = res.data.deniedList;
        if (pendingList != null) {
          pendingList.forEach((ele) => {
            ele.deniedUser = true;
            ele.showAccept = true;
          });
          this.pendingList = pendingList;
        }
        this.userCardConfig = [];
        let accept: UserCardConfig = new UserCardConfig(
          "Accept",
          this.acceptEmployee,
          this.canShow,
          true
        );
        accept.source = this;
        this.userCardConfig.push(accept);
      });
  }

  onsearch(val) {
    if (val != undefined) {
      val = val.trim().toLowerCase();
    }

    this.pendingList = this.temppendingList;
    this.pendingList = this.filterByString(this.temppendingList, val);
    if (this.pendingList.length == 0) {
      this.showNoDatafound = true;
    } else {
      this.showNoDatafound = false;
    }
  }
  keyupdata(event) {
    if (event.target.value.length == 0) {
      this.onsearch("");
    }
  }
  filterByString(data, s) {
    return data
      .filter((e) => e.userName.toLowerCase().includes(s))
      .sort((a, b) =>
        a.userName.toLowerCase().includes(s) &&
        !b.userName.toLowerCase().includes(s)
          ? -1
          : b.userName.toLowerCase().includes(s) &&
            !a.userName.toLowerCase().includes(s)
          ? 1
          : 0
      );
  }
  removeDuplicates(originalArray, prop) {
    var newArray = [];
    var lookupObject = {};

    for (var i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for (i in lookupObject) {
      newArray.push(lookupObject[i]);
    }
    return newArray;
  }

  sort_by_key(array, key) {
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }

  rejectEmployee(user: User) {
    let data: any = {};
    data.businessId = this.businessData.businessId;
    data.userId = user.userId;
    data.status = "REJECTED";
    this.util.startLoader();
    this.api.create("business/employee/request/reject", data).subscribe(
      (res) => {
        if (res.code == "00000") {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Employee Denied",

            showConfirmButton: false,
            timer: 2000,
          });
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Oops..",
            text: "Something went wrong. Please try again later.",
            showConfirmButton: false,
            timer: 3000,
          });
        }
        this.resetPayload();
        setTimeout(() => {
          this.requestlist();
          this.util.stopLoader();
        }, 2000);
      },
      (err) => {
        this.util.stopLoader();
      }
    );
  }

  ignoreEmployee(user: User) {
    let data: any = {};
    data.businessId = this.businessData.businessId;
    data.userId = user.userId;
    data.status = "IGNORED";
    this.util.startLoader();
    this.api.create("business/employee/request/reject", data).subscribe(
      (res) => {
        if (res.code == "00000") {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Employee ignored!",
            // text: 'Employee added successfully',
            showConfirmButton: false,
            timer: 2000,
          });
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Oops..",
            text: "Something went wrong. Please try again later.",
            showConfirmButton: false,
            timer: 3000,
          });
        }
        this.resetPayload();
        setTimeout(() => {
          this.requestlist();
          this.util.stopLoader();
        }, 2000);
      },
      (err) => {
        this.util.stopLoader();
      }
    );
  }

  acceptEmployee(user: User) {
    this.util.startLoader();

    let data: any = {};
    data.businessId = this.businessData.businessId;
    data.userId = user.userId;
    this.util.startLoader();
    this.api.create("business/employee/request/accept", data).subscribe(
      (res) => {
        if (res.code == "00000") {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Employee added successfully",
            // text: 'Employee added successfully',
            showConfirmButton: false,
            timer: 2000,
          });
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Oops..",
            text: "Something went wrong. Please try again later.",
            showConfirmButton: false,
            timer: 3000,
          });
        }
        this.resetPayload();
        setTimeout(() => {
          this.requestlist();
          this.util.stopLoader();
        }, 2000);
      },
      (err) => {
        this.util.stopLoader();
      }
    );
  }

  canShow(data, source): boolean {
    return true; // Always show buttons in employee requests context
  }

  userprofile(data) {
    var userData: any = {};
    userData.userId = data;

    this.router.navigate(["personalProfile"], { queryParams: userData });
  }

  setEmployeeRequestDetailOnBusiness(userdata) {
    this.values.menu = "requestsReceived";
    this.values.requestsReceived = this.sort_by_key(userdata, "firstName");
    this.values.requestsReceived = userdata;
    this.values.requestsReceived.forEach((element, i) => {
      if (element.userId == localStorage.getItem("userId")) {
        var b = this.values.requestsReceived[i];
        this.values.requestsReceived[i] = this.values.requestsReceived[0];
        this.values.requestsReceived[0] = b;
      }
    });

    // TODO: Replace with proper service-based communication instead of component method call
    // this.employee.employees();
  }

  // Updating search parameters, resetting scroll and totalCount, clearing employee list by Naaz
  updateSearch() {
    this.managePayload.searchContent = this.searchContent.trim() !== "" ? this.searchContent.trim() : null;
    this.managePayload.searchAfterKey = null;
    this.stopScroll = false;
    this.totalCount = 0;
    this.BusinessManageEmployess.next([]);
    this.requestlist();
  }
  // Resetting totalCount and emitting the search value to searchSubject by Naaz
  onSearchManage(val: string) {
    this.totalCount = 0;
    this.searchSubject.next(val);
  }
  // Triggering scroll event to load more data if stopScroll is false by Naaz
  onScrollDown() {
    if (!this.stopScroll) {
      this.loadScroll = true;
      this.scrollSubject.next(this.previouseAfterKey);
    }
  }
}

